import {
  isMissingSessionAuth401,
  notifySessionExpired,
} from '../../utils/authSessionExpired';
import { maybeRefreshSession, tryRecoverSession } from './sessionRefresh';

async function maybeNotifySessionExpired(response) {
  if (response.status !== 401) return;

  let bodyText = '';
  try {
    bodyText = await response.clone().text();
  } catch {
    bodyText = '';
  }

  if (isMissingSessionAuth401(response.status, bodyText)) {
    notifySessionExpired();
  }
}

function isRefreshRequest(input) {
  const url =
    typeof input === 'string'
      ? input
      : input instanceof Request
        ? input.url
        : String(input);
  return url.includes('/authentication-api/Refresh');
}

/** Shared fetch wrapper: sliding session refresh + login redirect on APIM auth 401s. */
export async function sessionAwareFetch(input, init) {
  if (!isRefreshRequest(input)) {
    await maybeRefreshSession();
  }

  let response = await fetch(input, init);

  if (
    response.status === 401 &&
    !isRefreshRequest(input) &&
    isMissingSessionAuth401(response.status, await response.clone().text())
  ) {
    const recovered = await tryRecoverSession();
    if (recovered) {
      response = await fetch(input, init);
    }
  }

  if (response.ok && !isRefreshRequest(input)) {
    void maybeRefreshSession();
  }

  await maybeNotifySessionExpired(response);
  return response;
}
